// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/business/commonLib.js'
import abLS from '@/business/abLocalStorage'
import * as Sentry from '@sentry/browser'
import App from './App.vue'
import Vue from 'vue'
import router from './router'
import { sync } from 'vuex-router-sync'
import store from './store'
import filters from './filters'
import tjStatistics from '@lib/business/tjStatistics' // 统计
import eventBus from '@/business/eventBus' // 全局公共事件

sync(store, router)
eventBus.initEventBus(store, router)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 执行初始化工作
store.dispatch('init')

let isInitStatistics = false
const _store = store
router.beforeResolve((to, from, next) => {
  // 判断路由需要登录，并且store中没有AccessToken并且localStorage中也没有，则跳转路由到登录页面
  _store.commit('setCurrentRoute', to)
  // 刷新之后需要从localStorage中获取
  const { name, meta, query, path, fullPath, params } = from
  const _from = { name, meta, query, path, fullPath, params }
  _store.commit('setFromRoute', !_from.name ? abLS.getFromRoute() || null : _from)
  if (!to.meta.noLogin && !_store.state.accessToken && !abLS.getAccessToken()) {
    router.replace({ name: 'login' })
    return
  }
  // 设置头部
  let headerTitle = _store.state.headerTitle
  if (to.matched.length < 2) {
    headerTitle = !to.matched[0].meta.headerTitle ? headerTitle : to.matched[0].meta.headerTitle
  } else {
    headerTitle = !to.matched[1].meta.headerTitle ? headerTitle : to.matched[1].meta.headerTitle
  }
  _store.commit('setHeaderTitle', `安伴管家-${headerTitle}`)

  next()
})
// 路由控制，用来处理一些全局状态
router.afterEach(route => {
  // 统计处理
  if (!isInitStatistics) {
    isInitStatistics = true
    tjStatistics.init(_store.state.host.BAIDU_PMS_APPKEY)
  }
})

/* eslint-disable no-new */
let app = new Vue({
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})

app.$mount('#app')

// 性能检测，首次有意义渲染超过4s，记录日志
if (window.performance && performance.now() > 4000) {
  Sentry.withScope(scope => {
    scope.setExtras([{ paintTime: performance.now(), timing: performance.timing.toJSON() }])
    Sentry.captureMessage('performance', Sentry.Severity.Info)
  })
}

window.$vm = app

export default app
